export const CLASSPREFIX = 'muze';
export const ARROW_RIGHT = 'right';
export const ARROW_TOP = 'top';
export const ARROW_BOTTOM = 'bottom';
export const ARROW_LEFT = 'left';
export const TOOLTIP_LEFT = 'left';
export const TOOLTIP_RIGHT = 'right';
export const TOOLTIP_BOTTOM = 'bottom';
export const TOOLTIP_TOP = 'top';
export const INITIAL_STYLE = {
    position: 'absolute',
    width: 0,
    height: 0
};
export const TABLE_FORMAT = 'table';
